/**
 * The address Chompdome publishes to players.
 *
 * A CONSTANT RATHER THAN A LITERAL, because the failure it prevents already happened once: the
 * privacy policy and terms pages were first written with the project owner's personal address in
 * them, which is not something a public page should ever carry. Anything player-facing that needs
 * a contact address imports this; a second page pasting a personal address in is then a change
 * somebody can see in review rather than a detail nobody looks at twice.
 *
 * Not the address that owns the Google Cloud project or the Cloudflare account — those are
 * operational identities and stay where they are. This is only what is shown to players.
 */
export const SUPPORT_EMAIL = 'support@chompdome.com';

/** `mailto:` href for the support address. */
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;
